var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9V13H7.5C6.57174 13 5.6815 13.3687 5.02512 14.0251C4.36874 14.6815 4 15.5717 4 16.5V27.5C4 29.432 5.568 31 7.5 31H24.5C25.4282 31 26.3184 30.6312 26.9748 29.9748C27.6312 29.3184 28 28.4282 28 27.5V16.5C28 15.5717 27.6312 14.6815 26.9748 14.0251C26.3184 13.3687 25.4282 13 24.5 13H24V9C24 6.87826 23.1572 4.84344 21.6568 3.34314C20.1566 1.84285 18.1217 1 16 1C13.8783 1 11.8434 1.84285 10.3431 3.34314C8.84286 4.84344 8 6.87826 8 9ZM21 13V9C21 7.67392 20.4732 6.40214 19.5355 5.46446C18.5979 4.52678 17.3261 4 16 4C14.6739 4 13.4021 4.52678 12.4645 5.46446C11.5268 6.40214 11 7.67392 11 9V13H21ZM24 16H24.5C24.6326 16 24.7598 16.0527 24.8536 16.1464C24.9474 16.2402 25 16.3674 25 16.5V27.5C25 27.6326 24.9474 27.7598 24.8536 27.8536C24.7598 27.9474 24.6326 28 24.5 28H7.5C7.3674 28 7.24022 27.9474 7.14644 27.8536C7.05268 27.7598 7 27.6326 7 27.5V16.5C7 16.3674 7.05268 16.2402 7.14644 16.1464C7.24022 16.0527 7.3674 16 7.5 16H24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSmall);
export default __webpack_public_path__ + "static/media/lockSmall.08268596.svg";
export { ForwardRef as ReactComponent };